import React from 'react';
import PilotLayout from '../pilot/PilotLayout';

export default function Layout({ children }) {
  return <PilotLayout>{children}</PilotLayout>;
}
